import React, { useEffect, useState } from 'react';
import { fetchBlogPosts } from '../../contentful';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";

function Blog() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const getPosts = async () => {
      const blogPosts = await fetchBlogPosts();
      setPosts(blogPosts);
      // setPosts(blogPosts.slice(0, 2)); // Show only the first 2 blogs
    };
    getPosts();
  }, []);

  return (
    <div className="blog-page">
      <Helmet>
        <title>Our Blog | Health Tips & Insights from Wholistic Nursing Care</title>
        <meta name="description" content="Stay updated with the latest health tips, wellness advice, and insights from the professionals at Wholistic Nursing Care." />
        <meta name="keywords" content="nursing blog, health tips Nairobi, healthcare insights, elderly care advice" />
        <link rel="canonical" href="https://wholistic.netlify.app/blog" />
      </Helmet>
      <h1 className="blog-title">Our Blog</h1>
      <p className="blog-intro">Insights, tips, and stories from our dedicated care team.</p>

      <div className="blog-grid">
        {posts.length === 0 ? (
          <p>Loading posts...</p>
        ) : (
          posts.map((post) => (
            <div key={post.sys.id} className="blog-entry">
              <Link to={`/blog/${post.fields.slug}`} className="blog-entry-link">
                <img
                  src={post.fields.featuredImage.fields.file.url}
                  alt={post.fields.title}
                  className="blog-entry-image"
                />
                <div className="blog-entry-content">
                  <h2>{post.fields.title}</h2>

                  {/* Display Author and Publish Date */}
                  <p className="blog-meta">
                    By {post.fields.author || "Unknown Author"} | {new Date(post.fields.publishDate).toLocaleDateString()}
                  </p>

                  <p>{post.fields.body.content[0].content[0].value.substring(0, 120)}...</p>
                  <span className="read-more">Read More →</span>
                </div>
              </Link>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default Blog;
